import { useEffect } from "react";

const useModalBackHandler = (isOpen, onClose) => {
  useEffect(() => {
    if (isOpen) {
      window.history.pushState({ modalOpen: true }, "");
      const handlePopState = () => onClose();
      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  }, [isOpen, onClose]);
};

export default useModalBackHandler;
